import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Chip, TableFooter } from "@mui/material";
import { DoneAll, Clear, ExpandMoreTwoTone, ExpandLessTwoTone } from "@mui/icons-material";
import React, {useEffect, useState} from 'react'
import { motion } from "framer-motion";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Laptop from '../Assets/laptop.png'
import Analysis from '../Assets/analysis.png'
import Factory from '../Assets/factory.png'
import Evaluation from '../Assets/evaluation.png'
import Decision from '../Assets/decision.png'
import CustomerService from '../Assets/customer-service.png'
import '../CSS/Module.css'

export default function Tannery() {
    const [pricing, setPricing] = useState(false);
    const [showAll, setShowAll] = useState(false);
    
    useEffect(() => {
      AOS.init({ duration: 1000 }); 
    }, []);

    const handleToggleChange = () => {
        setPricing(!pricing)
    }

    const features = [
        { name: "SMS Integration*", basic: true, advanced: true, premium: true },
        { name: "WhatsApp Integration*", basic: true, advanced: true, premium: true },
        { name: "Payment Gatway Integration*", basic: true, advanced: true, premium: true },
        { name: "User Role and Permission", basic: true, advanced: true, premium: true },
        { name: "Enquiry Management", basic: true, advanced: true, premium: true },
        { name: "Admission Management", basic: true, advanced: true, premium: true },
        { name: "Transport Management", basic: true, advanced: true, premium: true },
        { name: "Fee Management", basic: true, advanced: true, premium: true },
        { name: "Fee Dues Management", basic: true, advanced: true, premium: true },
        { name: "Fee Concession Management", basic: true, advanced: true, premium: true },
        { name: "Denominator", basic: true, advanced: true, premium: true },
        { name: "Attendance Management", basic: false, advanced: true, premium: true },
        { name: "I-Card Management", basic: false, advanced: true, premium: true },
        { name: "Student Gate Pass", basic: false, advanced: true, premium: true },
        { name: "Visitor Pass", basic: false, advanced: true, premium: true },
        { name: "Appreciation Certificate", basic: false, advanced: true, premium: true },
        { name: "Bonafide/TC/Fee Certificate", basic: false, advanced: true, premium: true },
        { name: "Exam Management", basic: false, advanced: true, premium: true },
        { name: "Time Table Management", basic: false, advanced: false, premium: true },
        { name: "Library Management", basic: false, advanced: false, premium: true },
        { name: "Homework Management", basic: false, advanced: false, premium: true },
        { name: "Notice Management", basic: false, advanced: false, premium: true },
        { name: "Employee Management", basic: false, advanced: false, premium: true },
        { name: "Account Management", basic: false, advanced: false, premium: true },
        { name: "Student Web Login", basic: false, advanced: false, premium: true },
        { name: "Student App", basic: false, advanced: false, premium: true },
        { name: "Teacher App", basic: false, advanced: false, premium: true },
    ];

    const plans = [
        { name: "Basic", color: "primary" },
        { name: "Advanced", color: "secondary", popular: true },
        { name: "Premium", color: "success" },
    ];

    const displayedFeatures = showAll ? features : features.slice(0, 10);

  return (
    <>
        <section id="Solutions" className="d-flex align-items-center pt-5">
            <div className="container" data-aos="fade-up">
                <div className="section-title">
                    <h2>Features</h2>
                    <h3>Footwear Production Management Software <span>Features</span></h3>
                </div>
                <div className="row shadow-sm mx-1">
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-end">
                        <img src={Laptop}alt="laptop" width="40" className="icon" />
                        <h4 className="title">Easy To Use</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center">
                        <img src={Analysis} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Focus on strategic planning</h4>
                    </div> 
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-md-start border-sm-top border-sm-end">
                        <img src={Factory} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Multiple Daily Production Report</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top border-md-end">
                        <img src={Evaluation} alt="laptop" width="40" className="icon " />
                        <h4 className="title">Matrix to deal with size and style</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top">
                        <img src={Decision} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Quick Decision Making</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top border-start">
                        <img src={CustomerService} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Customer Support 24*7</h4>
                    </div>
                </div>
                <nav className='my-5 mx-2'>
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <span className={`nav-link ${!pricing && 'active'}`} onClick={handleToggleChange}>Modules</span>
                      </li>
                      {/* <li className="nav-item">
                        <span className={`nav-link ${pricing && 'active'}`} onClick={handleToggleChange}>Pricing</span>
                      </li> */}
                    </ul>
                </nav>
                {!pricing &&
                    <div className="container">
                        <div className="section-title" data-aos="fade-up">
                          <h2>Modules</h2>
                          <h3>Software Module <span>Details</span></h3>
                        </div>
                        <div className="row">
                            <div className="col-md-4" data-aos="fade-right">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Product Design</h5>
                                        <li>Component</li>
                                        <li>Process</li>
                                        <li>Article Profile</li>
                                        <li>Pre Production Costing</li>
                                        <li>Post Production Costing</li>
                                    </ul>
                                    <ul>
                                        <h5>Order Management</h5>
                                        <li>Buyer/Agents</li>
                                        <li>Price list of Buyers</li>
                                        <li>Price History</li>
                                        <ul>
                                            <h5>Order Category</h5>
                                            <li>Sample</li>
                                            <li>Domestic</li>
                                            <li>Exports</li>
                                        </ul>
                                        <li>Proforma Invoice</li>
                                    </ul>
                                    <ul>
                                        <h5>Purchase Management</h5>
                                        <li>Supplier/Vendor</li>
                                        <li>Price list of Supplier/Vendor</li>
                                        <li>Price History</li>
                                        <li>Purchase Order</li>
                                        <li>(A) Material Requirement Planning</li>
                                        <li>(B) Stock Purchase</li>
                                        <li>Material Requirement as per Orders</li>
                                        <li>Pending Purchase Order</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4" data-aos="fade-down">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Inventory Management</h5>
                                        <li>Item (Material) Category</li>
                                        <li>Item (Material)</li>
                                        <li>Store/Sub Store</li>
                                        <li>Issue/return Item</li>
                                        <li>Date Wise Material In/Out Report</li>
                                        <li>Raw Item (Material) Stock</li>
                                        <li>Month Stock with Opening Balance/Purchase/Consume/Closing Balance</li>
                                    </ul>
                                    <ul>
                                        <h5>Production Management</h5>
                                        <li>Job Process</li>
                                        <li>Production Report</li>
                                        <li>Material Requirement Sheet</li>
                                        <li>Purchase /GRN Register</li>
                                        <li>Job Card</li>
                                        <li>Packing
                                            <li>Domestic</li>
                                            <li>Export</li>
                                        </li>
                                        <li>Job Card Submit</li>
                                        <li>Daily Production Report</li>
                                    </ul>
                                    <ul>
                                        <h5>Wages</h5>
                                        <li>Worker/Contractor</li>
                                        <li>Worker Advance and Deduction</li>
                                        <li>Create Wages</li>
                                        <li>Paid Wages</li>
                                        <li>Advance Summary Report</li>
                                        <li>Wages Summary Report</li>
                                        <li>Worker Wages Ledger</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4" data-aos="fade-up">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Sales</h5>
                                        <li>Invoice Domestic</li>
                                        <li>Invoice Export</li>
                                        <li>Dispatch</li>
                                        <li>Sales Order Status Report</li>
                                    </ul>
                                    <ul>
                                        <h5>Payroll</h5>
                                        <li>Employee</li>
                                        <li>Attendance</li>
                                        <li>Employee Advance and Deduction</li>
                                        <li>Create Salary</li>
                                        <li>Paid Salary</li>
                                        <li>Advance Summary Report</li>
                                        <li>Salary Summary Report</li>
                                    </ul>
                                    <ul>
                                        <h5>User Privilege</h5>
                                        <li>User Master</li>
                                        <li>User Role/Permission</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {pricing &&
                  <Box sx={{ maxWidth: 1400, mx: "auto", textAlign: "center", p: 2 }} data-aos="fade-down">
                    <Typography variant="h3" fontWeight={600} color="primary" gutterBottom>Compare Plans</Typography>
                    <TableContainer sx={{ overflow: "scroll" }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell align="center" sx={{ transform: "scale(1.1)", background: "#D0021B", color: "white", fontWeight: "bold", fontSize: "0.8rem", padding: "4px 10px", borderTopLeftRadius: '10px', borderTopRightRadius: '10px', boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)"}}>Most Popular</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                          <TableRow sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"}}>
                            <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "1.2rem", borderTopLeftRadius: '10px' }}>Features</TableCell>
                            {plans.map((plan, idx) => (
                              <TableCell key={idx} sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, position: "relative", transform: plan.popular ? "scale(1.1)" : "none", zIndex: plan.popular ? 2 : 1, backgroundColor: plan.popular ? "rgba(255, 255, 255, 0.2)" : "inherit", backdropFilter: plan.popular ? "blur(5px)" : "none", borderRadius: plan.popular ? "8px" : "0px", borderTopRightRadius: plan.popular ? "0px" : "10px", boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none" }} align="center">
                                {plan.name}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayedFeatures.map((feature, index) => (
                            <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff", "& td": { py: 1 } }}>
                              <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>{feature.name}</TableCell>
                              {plans.map((plan, idx) => (
                                <TableCell key={idx} align="center" sx={{
                                  transform: plan.popular ? "scale(1.1)" : "none",
                                  zIndex: plan.popular ? 2 : 1,
                                  backgroundColor: plan.popular ? "rgba(255, 255, 255, 0.3)" : "inherit",
                                  backdropFilter: plan.popular ? "blur(5px)" : "none",
                                  borderRadius: plan.popular ? "8px" : "0px",
                                  boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.5)" : "none"
                                }}>
                                  {feature[plan.name.toLowerCase()] ? (
                                    <motion.div whileHover={{ scale: 1.2 }}>
                                      <DoneAll color="success" fontSize="medium" />
                                    </motion.div>
                                  ) : (
                                    <motion.div whileHover={{ scale: 1.2 }}>
                                      <Clear color="error" fontSize="medium" />
                                    </motion.div>
                                  )}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                        <TableFooter>
                          <Chip sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)", background: "#D0021B", color: "#fff", zIndex: 3 }} icon={showAll ? <ExpandLessTwoTone color="white" /> : <ExpandMoreTwoTone color="white" />} onClick={() => setShowAll(!showAll)} label={showAll ? "Show Less" : "View More"} />
                          <TableRow sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"}}>
                            <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, borderTopLeftRadius: '10px' }}>NO OF STUDENTS</TableCell>
                            {plans.map((plan, idx) => (
                              <TableCell key={idx} sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, position: "relative", transform: plan.popular ? "scale(1.1)" : "none", zIndex: plan.popular ? 2 : 1, backgroundColor: plan.popular ? "rgba(255, 255, 255, 0.2)" : "inherit", backdropFilter: plan.popular ? "blur(5px)" : "none", borderRadius: plan.popular ? "8px" : "0px", borderTopRightRadius: plan.popular ? "0px" : "10px", boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none" }} align="center">
                                {plan.name}
                              </TableCell>
                            ))}
                          </TableRow>
                          <TableRow sx={{ backgroundColor: "#f9f9f9", "& td": { py: 1 } }}>
                            <TableCell sx={{  background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>Upto 300</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">9,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">14,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">19,999/Year</TableCell>
                          </TableRow>
                          <TableRow sx={{ backgroundColor: "#fff", "& td": { py: 1 } }}>
                            <TableCell sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>301- 500</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">14,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">19,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">24,999/Year</TableCell>
                          </TableRow>
                          <TableRow sx={{ backgroundColor: "#f9f9f9", "& td": { py: 1 } }}>
                            <TableCell sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>500 +</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">Rs. 5/Per Student/Per Month</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">Rs 7/Per Student/Per Month</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">Rs 10/Per Student/Per Month</TableCell>
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </Box>
                }
            </div>
        </section>
    </>
  )
}

